import React from "react";
import { connect } from "react-redux";
import { NavItem } from "reactstrap";

import userManager from "../services/UserManager";

const LoginButton = () => {
    var onClick = (e) => {
        e.preventDefault();
        userManager.signinRedirect();
        };
    return (
        <NavItem>
            <button onClick={onClick} className="text-dark btn btn-link">Login</button>
        </NavItem>
    );
}
export default connect()(LoginButton);
